import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { useUserContext } from '@/context'

import { createAPIOptions, createAPIQueryFunction, useAPIOptions } from './'
import { useAPIDest } from './useAPI.types'
import { createAPIQueryKey, gambitDefaultAPIOptions } from './useAPI.util'

type APIQueryOptions<TData, TError> = Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>

export function useAPI<TData = unknown, TError = unknown>(
  dest: useAPIDest,
  options?: useAPIOptions<APIQueryOptions<TData, TError>>,
) {
  const { user } = useUserContext()

  const gambitOptions = {
    ...options,
    headers: { ...options?.headers, ...gambitDefaultAPIOptions?.headers },
  }

  const { headers, data, params, nonKeyParams, ...queryOptions } = createAPIOptions<APIQueryOptions<TData, TError>>(
    gambitOptions,
    user,
  )

  const queryFnOptions = { headers, data, params, nonKeyParams }
  const queryFn = createAPIQueryFunction(dest, queryFnOptions)
  const queryKey = createAPIQueryKey(dest, params)

  return useQuery<TData, TError>({ queryKey, queryFn, ...queryOptions })
}
